<template>
  <div :class="{ 'has-focus': hasFocus }" class="variable-in-use-selector" v-if="variable">
    <div>
      <span :title="variable.name" class="name"> {{ name }}: </span>
      <span class="count" :title="'Times used in the template: ' + count"> {{ count }}x </span>
    </div>
    <select :name="variable.name" :id="variable.name" v-model="value" class="variation-selector">
      <option :value="variable.value">{{ variable.value }}</option>
      <option v-for="(variation, index) in values.filter((v) => v != value)" :key="index" :value="variation">{{
        variation
      }}</option>
    </select>
  </div>
</template>

<script>
import EventBus from "@/assets/js/eventBus.js";
export default {
  props: {
    variable: Object,
    count: Number,
    variations: Object
  },
  data() {
    return {
      hasFocus: false,
      values: []
    };
  },
  methods: {
    onValueChange(value) {
      this.variable.value = value;
      this.$store
        .dispatch("getTemplatePreview", {
          template: this.$store.state.template,
          variables: this.$store.state.templateVariables
        })
        .then((preview) => {
          // this.$store.state.templatePreview = preview;
          this.$store.commit("setTemplatePreview", preview);
        });
      EventBus.$emit("variable-change", this.variable);
    }
  },
  computed: {
    name() {
      // if this.variable.name -> contains ' _ ' and does not have a displayName, we should assume that its an extraVariable?
      if (!this.variable.displayName && this.variable.name.includes("_"))
        return this.variable.name.substring(this.variable.name.lastIndexOf("_") + 1, this.variable.name.length - 1);
      // Formatting the extra-variables
      else return this.variable.displayName ? this.variable.displayName : this.variable.name.replace(/[{}]/g, "");
    },
    value: {
      get() {
        return this.variable.value;
      },
      set(value) {
        this.onValueChange(value);
      }
    }
  },
  mounted() {
    this.values = this.variations && this.variations ? this.variations.values : [];
  }
};
</script>

<style lang="less">


.variable-in-use-selector{
    margin:0  calc(45px - 12px);
    padding: 0 12px;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 8px;
  .count{
    opacity: 0.4;
  }
  .name {
    font-weight: 500;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .variation-selector{
    background: inherit;
    color: var(--alabaster);
    border-radius: 4px;
    padding: 4px;


  }  

}
</style>
